const STORAGE_KEY = "fatihoune_marketing_attribution";

const utmKeys = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function canUseBrowserStorage() {
  return typeof window !== "undefined" && window.localStorage;
}

export function captureMarketingAttribution() {
  if (!canUseBrowserStorage()) return {};

  const params = new URLSearchParams(window.location.search);
  const utm = utmKeys.reduce((acc, key) => {
    const value = params.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {});

  const existing = getMarketingAttribution();
  const hasUtm = Object.keys(utm).length > 0;
  const attribution = {
    ...existing,
    ...(hasUtm ? utm : {}),
    landingPage: existing.landingPage || window.location.pathname,
    lastPage: window.location.pathname,
    referrer: existing.referrer || document.referrer || "",
    capturedAt: existing.capturedAt || new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  return attribution;
}

export function getMarketingAttribution() {
  if (!canUseBrowserStorage()) return {};

  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
  } catch (error) {
    return {};
  }
}
